import React from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "./../../assets/images/games-icon/leftbar/Home.png";
import CricketIcon from "./../../assets/images/games-icon/leftbar/Cricket.png";
import BonusIcon from "./../../assets/images/games-icon/leftbar/money.png"
import SportsbookIcon from "./../../assets/images/games-icon/leftbar/football.png"

import JetX from "./../../assets/images/games-icon/jetx-logo.svg";
import { RouteType, useAppNavigate } from "../../hooks/useAppNavigate";

const LeftBarSports = () => {
  const navigate = useNavigate();
  const { appNavigate } = useAppNavigate();

  return (
    <>
      <div className="leftbarSec d-none d-md-block">
        <ul>
          <li>
            <a
              className="active"
              href="javascript:void(0)"
              onClick={() => {
                appNavigate("/sports", RouteType.Protected);
              }}
            >
              <img src={HomeIcon} alt="Home Icon" />
              <span>Lobby</span>
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => {
                appNavigate("/sports/jetfair?sportName=cricket", RouteType.Protected);
              }}
            >
              <img src={CricketIcon} alt="Cricket Icon" />
              <span>Cricket</span>
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => {
                appNavigate("/sports/ig_pixel", RouteType.Protected);
              }}
            >
              <img src={SportsbookIcon} alt="Cricket Icon" />
              <span>Sportsbook</span>
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => {
                appNavigate("/bonus", RouteType.Protected);
              }}
            >
              <img src={BonusIcon} alt="Cricket Icon" />
              <span>Bonus</span>
            </a>
          </li>
          <li>
            <a
              onClick={() => {
                appNavigate(
                  "/casino/aggapsmartsoftgaming-jetx",
                  RouteType.Protected,
                );
              }}
              href="javascript:void(0)"
            >
              <img src={JetX} alt="horseracing Icon" />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
